// extracted by mini-css-extract-plugin
export default {"image":"Image_image__XXYIp","circle":"Image_circle__BEy7r","grey":"Image_grey__Bf6A6"};